export default {
  app: {
    tradeOffers: {
      country: 'Pays',
      loginPrompt: 'Pour voir les offres commerciales, vous devez {0}.',
      logIn: 'se connecter',
    },
  },
};
